import {defineStore} from 'pinia';
import { ref, watch } from 'vue';

export type ColorScheme = 'light' | 'dark';

export const useThemeStore = defineStore('theme', () => {
	const colorScheme = ref<ColorScheme>('light');

	const getSavedColorScheme = (): ColorScheme|null => {
		return window.sessionStorage.getItem('color-scheme') as ColorScheme;
	};

	const getSystemColorScheme = (): ColorScheme => {
		if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
			return 'dark';
		}
		return 'light';
	};

	const toggleDocumentAttribute = (): void => {
		document.documentElement.dataset.appColorTheme = colorScheme.value;
	}

	const save = (scheme:ColorScheme): void => {
		window.sessionStorage.setItem('color-scheme', scheme);
	};

	const init = (): void => {
		const savedColorScheme = getSavedColorScheme();
		const systemColorScheme = getSystemColorScheme();
		colorScheme.value = savedColorScheme || systemColorScheme || 'light';
		toggleDocumentAttribute();
	}

	watch(colorScheme, (): void => {
		toggleDocumentAttribute();
	});

	return {
		colorScheme,
		init,
		save
	};
})
